(() => {
  const script = document.currentScript;
  const section = document.getElementById(`shopify-section-${script?.dataset.sectionId}`);

  if (!section) {
    return;
  }

  const randomIndex = (length) => {
    const randomValue = new Uint32Array(1);
    window.crypto.getRandomValues(randomValue);

    return randomValue[0] % length;
  };

  const shuffle = (items) => {
    for (let index = items.length - 1; index > 0; index -= 1) {
      const targetIndex = randomIndex(index + 1);
      [items[index], items[targetIndex]] = [items[targetIndex], items[index]];
    }

    return items;
  };

  const getProductGroup = (card) => card.dataset.productGroup || card.getAttribute('handle');

  const getColumnCount = (cards) => {
    const firstRowOffset = cards[0].offsetTop;
    let columnCount = 0;

    for (const card of cards) {
      if (card.offsetTop !== firstRowOffset) {
        break;
      }

      columnCount += 1;
    }

    return Math.max(columnCount, 1);
  };

  const hasRepeatedModelInRow = (cards, columnCount) => {
    for (let rowStart = 0; rowStart < cards.length; rowStart += columnCount) {
      const modelsInRow = new Set();
      const rowEnd = Math.min(rowStart + columnCount, cards.length);

      for (let index = rowStart; index < rowEnd; index += 1) {
        const group = getProductGroup(cards[index]);

        if (modelsInRow.has(group)) {
          return true;
        }

        modelsInRow.add(group);
      }
    }

    return false;
  };

  const buildRowSafeOrder = (cards, columnCount) => {
    const groups = new Map();

    for (const card of cards) {
      const group = getProductGroup(card);
      const groupedCards = groups.get(group) || [];
      groupedCards.push(card);
      groups.set(group, groupedCards);
    }

    for (const groupedCards of groups.values()) {
      shuffle(groupedCards);
    }

    let itemsRemaining = cards.length;
    let rowsRemaining = Math.ceil(itemsRemaining / columnCount);
    const orderedCards = [];

    while (groups.size > 0) {
      const rowSize = Math.min(columnCount, itemsRemaining);
      const mandatoryGroups = [];
      const optionalGroups = [];

      for (const groupEntry of groups.entries()) {
        if (groupEntry[1].length > rowsRemaining) {
          return null;
        }

        const target = groupEntry[1].length === rowsRemaining ? mandatoryGroups : optionalGroups;
        target.push(groupEntry);
      }

      if (mandatoryGroups.length > rowSize || mandatoryGroups.length + optionalGroups.length < rowSize) {
        return null;
      }

      shuffle(optionalGroups);
      const selectedGroups = [
        ...mandatoryGroups,
        ...optionalGroups.slice(0, rowSize - mandatoryGroups.length)
      ];
      shuffle(selectedGroups);

      for (const [selectedGroup, selectedCards] of selectedGroups) {
        orderedCards.push(selectedCards.pop());
        itemsRemaining -= 1;

        if (selectedCards.length === 0) {
          groups.delete(selectedGroup);
        }
      }

      rowsRemaining -= 1;
    }

    return orderedCards;
  };

  const shuffleProductList = (productList) => {
    const cards = [...productList.querySelectorAll(':scope > product-card')];

    if (cards.length < 2) {
      return;
    }

    const columnCount = getColumnCount(cards);

    if (productList.dataset.shuffleColumns === String(columnCount)) {
      return;
    }

    const orderedCards = buildRowSafeOrder(cards, columnCount);

    if (!orderedCards || hasRepeatedModelInRow(orderedCards, columnCount)) {
      return;
    }

    productList.dataset.shuffleColumns = String(columnCount);
    productList.append(...orderedCards);
  };

  const observedProductLists = new WeakSet();
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      shuffleProductList(entry.target);
    }
  });

  const shufflePendingLists = () => {
    for (const productList of section.querySelectorAll('product-list[data-shuffle-products]')) {
      shuffleProductList(productList);

      if (!observedProductLists.has(productList)) {
        observedProductLists.add(productList);
        resizeObserver.observe(productList);
      }
    }
  };

  shufflePendingLists();

  const observer = new MutationObserver(shufflePendingLists);
  observer.observe(section, {
    attributes: true,
    attributeFilter: ['collection-mobile-layout', 'collection-desktop-layout'],
    childList: true,
    subtree: true
  });
})();
